export const SET_CURRENT_PATIENT = 'main/SET_CURRENT_PATIENT';
export const UNSET_CURRENT_PATIENT = 'main/UNSET_CURRENT_PATIENT';

export const setPatient = id => ({
  type: SET_CURRENT_PATIENT,
  id,
});

export const unsetPatient = () => ({
  type: UNSET_CURRENT_PATIENT,
});



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./main/actions/current-patient-actions.ts